module.exports = __webpack_public_path__ + "img/9_A Deal become Inactve.e5c41555.svg";